<script setup>
import { computed } from "vue";
import { normalizeHexColor } from "@/utils/formatters";

const props = defineProps({
  id: {
    type: String,
    default: undefined,
  },
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "blur"]);

const normalizedColor = computed(() => normalizeHexColor(props.modelValue));
const inputValue = computed(() => normalizedColor.value || "#000000");

function onInput(event) {
  emit("update:modelValue", normalizeHexColor(event?.target?.value));
}

function onBlur() {
  emit("blur");
}
</script>

<template>
  <div
    class="route-color-control"
    :class="{
      'is-invalid': error,
      'is-empty': !normalizedColor,
    }"
  >
    <div
      class="route-color-swatch"
      :style="{ backgroundColor: normalizedColor || 'transparent' }"
    />
    <input
      :id="id"
      :value="inputValue"
      type="color"
      class="route-color-native-input"
      @input="onInput"
      @blur="onBlur"
    />
  </div>
</template>

<style scoped>
.route-color-control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 1.30rem;
  height: 1.30rem;
  min-width: 1.30rem;
  cursor: pointer;
  padding: 0 !important;
}

.route-color-control:focus-within .route-color-swatch {
  box-shadow: 0 0 0 3px rgba(94, 114, 228, 0.16);
}

.route-color-swatch {
  width: 100%;
  min-width: 100%;
  height: 100%;
  border-radius: 999px;
  border: 1px solid rgba(17, 24, 39, 0.1);
}

.route-color-control.is-empty .route-color-swatch {
  border: 1px dashed rgba(17, 24, 39, 0.2);
  background:
    linear-gradient(45deg, rgba(17, 24, 39, 0.04) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(17, 24, 39, 0.04) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(17, 24, 39, 0.04) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(17, 24, 39, 0.04) 75%) !important;
  background-position: 0 0, 0 4px, 4px -4px, -4px 0;
  background-size: 8px 8px;
}

.route-color-control.is-invalid .route-color-swatch {
  border-color: #fd5c70;
  box-shadow: 0 0 0 3px rgba(253, 92, 112, 0.12);
}

.route-color-native-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: 0;
  outline: 0;
  box-shadow: none;
  cursor: pointer;
}

.route-color-native-input:focus,
.route-color-native-input:focus-visible,
.route-color-native-input:invalid {
  outline: 0;
  box-shadow: none;
}
</style>
